import React from 'react';
import Text from './Text';
import { colors } from '../../tailwind';

const StatusTag = function({ status, isHost }) {
  switch (status) {
    case 'pending':
      return !isHost ? null : (
        <div className="inline-block p-sxx b-1 brad-md b-primary-light">
          <Text large primaryLight>
            Pending
          </Text>
        </div>
      );
    case 'completed':
      return (
        <Text large primaryLight>
          Completed
        </Text>
      );
    case 'accepted':
      return (
        <Text large bold primaryLight>
          Accepted
        </Text>
      );
    case 'declined':
      return (
        <Text large bold primaryDark>
          Declined
        </Text>
      );
    case 'expired':
      return (
        <Text large bold primaryDark>
          Expired
        </Text>
      );
    case 'cancelledByHost':
    case 'cancelledByGuest':
      return (
        <Text large bold primaryDark>
          Cancelled
        </Text>
      );
    default:
      return null;
  }
};

export default StatusTag;



// WEBPACK FOOTER //
// ./src/components_new/common/StatusTag.js